import { combineEpics } from 'redux-observable';

import { cancelCooperationByClientEpic } from './feedback-form/feedback-form';
import { requestCooperationByClientEpic } from './freelancer-accept-popup/freelancer-accept-popup';
import {
    freelancerCardEditImageUploadEpic,
    freelancerCardEditInitialFetchEpic,
    updateFreelancerCardItemEpic
} from './freelancer-card-edit/freelancer-card-edit';
import {
    freelancerCardEpic,
    freelancerCardRegisteredEpic,
    updateFreelancerStatusEpic,
    withdrawRequestByClientEpic
} from './freelancer-card/freelancer-card';
import {
    acceptCustomerProjectEpic,
    closeProjectByFreelancer,
    declineCustomerRequestEpic,
    fetchFreelancerCustomersDataEpic
} from './freelancer-customers/freelancer-customers';
import {
    addFreelancerFeedbackEpic,
    deleteFreelancerFeedbackEpic,
    updateFreelancerFeedbackEpic
} from './freelancer-feedback/freelancer-feedback';
import { fetchFreelancersListDataEpic } from './freelancers-list/freelancers-list';

export const epics = [
    freelancerCardEpic,
    freelancerCardRegisteredEpic,
    updateFreelancerStatusEpic,
    requestCooperationByClientEpic,
    acceptCustomerProjectEpic,
    declineCustomerRequestEpic,
    closeProjectByFreelancer,
    fetchFreelancerCustomersDataEpic,
    cancelCooperationByClientEpic,
    withdrawRequestByClientEpic,
    fetchFreelancersListDataEpic,
    addFreelancerFeedbackEpic,
    updateFreelancerFeedbackEpic,
    deleteFreelancerFeedbackEpic,
    freelancerCardEditInitialFetchEpic,
    updateFreelancerCardItemEpic,
    freelancerCardEditImageUploadEpic
];

export const freelancers = combineEpics(...epics);
